// @ts-nocheck
import Sheet from "atoms/sheet/sheet";
import _ from "lodash";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import ActionBar from "pages/orders/actionBar/actionBar";
import qs from "qs";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import ThetaGridPaginated from "templates/thetaGridPaginated";
import * as constants from "./constants";
import HealthCheck from "./healthCheck/healthCheck";
import * as sagaActions from "./sagaActions";
import * as selectors from "./selectors";
import { TTableTab } from "./types";
import { getTableIdSelector } from "./actionBar/query";
import DropDown from "atoms/dropdown/dropdown";
import * as dynamicGridSelectors from "models/dynamicGrid/selector";
import * as dynamicGridSagaActions from "models/dynamicGrid/sagaActions";
import Label from "atoms/label/label";
import { getStatusQuery } from "./query";
import { checkFilterOpen } from "templates/thetaGridPaginated/query";
import OrderSummary from "./summary";
import KitsModal from "organisms/kitsModal";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import { resetTableColumnsAg } from "models/tableColumns/sagaActions";
import { REQUESTS } from "utils/services/thetaretail/requests";
import GridActionBar from "atoms/GridActionBar";
import { getWebAppSettings } from "models/user/selector";
import { fetchBookmarksList } from "models/bookmarks/sagaActions";
import { Typography } from "antd";
export interface Props {
  title: string;
}
interface LocationState {
  from: {
    pathname: string;
  };
}
export interface DropdownType {
  displayName: string;
  value: string;
}
const { Title } = Typography;

const Orders: React.FunctionComponent<Props> = ({ title }) => {
  const navigate = useNavigate();
  const location = useLocation<LocationState>();
  const query = qs.parse(location.search.replace("?", ""));
  const [gridRef, handleGridRef] = React.useState(null);
  const orderTabs = useSelector(selectors.getOrderTabs);
// console.log(orderTabs,"orderTabs");
  const getUrl = (value) => {
    let url;
    switch (value) {
      case 1:
        url = "/orders?selectedTab=skus";
        break;
      case 2:
        url = "/orders?selectedTab=items";
        break;
      case 30:
        url = "/orders?selectedTab=kits";
        break;
      case 115:
        url = "/orders?selectedTab=pivot";
        break;
      default:
        url = "/orders?selectedTab=all";
        break;
    }
    return url;
  };
  const getActiveTable = React.useCallback(() => {
    if (
      !orderTabs?.find(
        (t) =>
          t.tableId === constants.ORDER_TABS[query.selectedTab?.toUpperCase()]
      )
    ) {
      navigate(getUrl(orderTabs[0].tableId));
      return orderTabs[0];
    }
    switch (query.selectedTab) {
      case "skus":
        if (orderTabs[2]?.isEnabled) {
          return orderTabs[2];
        }
        break;
      case "items":
        if (orderTabs[3]?.isEnabled) {
          return orderTabs[3];
        }
        break;
      case "kits":
        if (orderTabs[1]?.isEnabled) {
          return orderTabs[1];
        }
        break;
      case "pivot":
        if (orderTabs[4]?.isEnabled) {
          return orderTabs[4];
        }
        break;
      default:
        return orderTabs[0];
    }
  }, [query.selectedTab]);

  const [isFilterEnabled, updateFilterEnabled] = React.useState(false);
  const [activeTable, setActiveTable] = React.useState<TTableTab>(
    getActiveTable()
  );
  const dispatch = useDispatch();
  const loading = useSelector((state) => selectors.getLoadingStatus(state));
  const info = useSelector((state) => selectors.getOrderInfo(state));
  const isHealthCheckActive = useSelector((state) =>
    selectors.isHealthCheckActive(state)
  );
  const filters = useSelector((state) =>
    dynamicGridSelectors.getGridFilters(state, Number(activeTable.tableId))
  );
  const dataLoading = useSelector((state) =>
    dynamicGridSelectors.isLoading(state, activeTable.tableId.toString())
  );
  const gridMeta = useSelector((state) =>
    dynamicGridSelectors.getGridMetadata(state, Number(activeTable.tableId))
  );

  const isGroupMode = Boolean(
    gridRef?.current?.columnApi?.columnModel?.pivotMode ||
      gridRef?.current?.columnApi?.columnModel?.rowGroupColumns?.length
  );

  React.useEffect(() => {
    setActiveTable(getActiveTable());
  }, [query]);

  React.useEffect(() => {
    dispatch(dynamicGridSagaActions.erpEnabled({ tableId: 116 }));
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      dynamicGridSagaActions.erpEnabled({ tableId: activeTable.tableId })
    );
    dispatch(fetchBookmarksList({ tableId: activeTable.tableId }));
  }, [activeTable.tableId, dispatch]);

  // React.useEffect(() => {
  //   if (!filters?.search) {
  //     return;
  //   }
  //   dispatch(
  //     sagaActions.getOrdersSummaryInfo({
  //       search: _.get(filters, "search"),
  //       tableId: activeTable.tableId,
  //     })
  //   );
  // }, [dispatch, activeTable, filters?.search]);

  const closeHealthCheck = React.useCallback(() => {
    dispatch(sagaActions.toggleHealthCheck({ isEnabled: false }));
  }, [dispatch]);

  const updateActiveTable = React.useCallback(
    ({ value }: { value: number }, tableId) => {
      let url = getUrl(value);
      navigate(url);

      const active = orderTabs.find((tabType) => tabType.tableId === tableId);
      setActiveTable(active);
    },
    [dispatch]
  );

  const handleResetViewClick = async () => {
    dispatch(resetTableColumnsAg(activeTable.tableId));
  };
  const isView = useSelector(
    (state) => getWebAppSettings(state)?.IsAclRowLevelAccessEnabled
  );

  const gridConfig = {
    enableSelection: true,
    enableSorting: true,
    rowGroupPanelShow:
      activeTable.tableId === constants.ORDER_TABS.ALL ||
      activeTable.tableId === constants.ORDER_TABS.ITEMS ||
      activeTable.tableId === constants.ORDER_TABS.SKUS,
    // defaultRowGroupColumn: activeTable.tableId === Number(constants.ORDER_TABS.KITS) ? 'OrderKitID' : null,
    // defaultRowGroupColumnDisplayOverride:
    //  activeTable.tableId === Number(constants.ORDER_TABS.KITS) ? 'Kit-KitDescription' : null,
    rowPivotPanelShow:
      activeTable.tableId === constants.ORDER_TABS.ALL ||
      activeTable.tableId === constants.ORDER_TABS.ITEMS ||
      activeTable.tableId === constants.ORDER_TABS.SKUS,
    // rowPivotPanelShow: (activeTable.tableId !== constants.ORDER_TABS.KITS),
    isViewImplementationOverride:
      isView || activeTable.tableId === Number(constants.ORDER_TABS.KITS),
    enableMultiSort: true,
    // extraFilter: activeTable.tableId === constants.ORDER_TABS.ALL ? {
    //  // endRow: 50,
    //  // filterModel: {},
    //  // groupKeys: [],
    //  pivotCols: [{
    //    aggFunc: "min",
    //    displayName: "Order Number",
    //    field: "OrderNumber",
    //    id: "OrderNumber",
    //  }],
    //  pivotMode: true,
    //  // sortModel: [],
    //  // startRow: 0,
    //  rowGroupCols: [
    //    {
    //      aggFunc
    //        :
    //        "min",
    //      displayName
    //        :
    //        "Store",
    //      field
    //        :
    //        "Store",
    //      id
    //        :
    //        "Store"
    //    }
    //  ],
    //  // valueCols:
    //    // [{ id: 'OrderNumber', aggFunc: 'min', displayName: 'Order Number', field: 'OrderNumber' }
    //      // ,
    //    // { id: 'CustomerNum', aggFunc: 'min', displayName: 'Customer Number', field: 'CustomerNum' }
    //      // ,
    //    // { id: 'OrderBatchID', aggFunc: 'min', displayName: 'Order Batch ID', field: 'OrderBatchID' }
    //  // ]
    // } : {},
    selectionCallBack: () => {},
    groupLockGroupColumns:
      activeTable.tableId === constants.ORDER_TABS.PIVOT ? -1 : 0,
  };

  const isFilterOpen = () => {
    if (isFilterEnabled) {
      return true;
    }
    if (checkFilterOpen(filters, activeTable.tableId)) {
      updateFilterEnabled(true);
      return true;
    }
  };

  const templateConfig = React.useMemo(
    () => ({
      gridConfig,
      isFilterEnabled:
        (isFilterEnabled === undefined ? false : isFilterEnabled) ||
        isFilterOpen(),
      tableId: activeTable.tableId,
      // groupBy: activeTable.tableId === 30 ? 'OrderKitID' : null,
      selectRowKey: getTableIdSelector(activeTable.tableId),
      childTableSelectRowKey: "OrderDetailVarietyID",
      dataProviderOptions: {
        type: "POST",
        version: 2,
        ...REQUESTS.POST.GET_GRID_DETAILS_V2,
        pathParams: {
          tableId: activeTable.tableId,
        },
        body: {},
        // body: activeTable.tableId === constants.ORDER_TABS.ALL ?
        //  { "search": "{\"filter\":[{\"field\":\"OrderStatusID\",\"value\":\"3\",\"type\":\"number\",\"queryName\":\"OrderStatusID\"}]}", "rowGroupCols": [{ "AliasName": "Store", "QueryName": "Store" }], "groupKeys": [], "pivotColumns": [{ "AliasName": "OrderNumber", "QueryName": "ISNULL(o.OrderNumber, o.OrderID)" }], "isPivotMode": true, "groupAggregation": [{ "QueryName": "min(StoreDescription)", "AliasName": "StoreDescription" }, { "QueryName": "min(StoreAttribute10)", "AliasName": "StoreAttribute10" }, { "QueryName": "min(ERPStoreID)", "AliasName": "ERPStoreID" }, { "QueryName": "min(StorePercentageFullfillment)", "AliasName": "StorePercentageFullfillment" }], "tableId": 23, "pageNumber": 1, "itemsPerPage": 50, "sortDirection": "DESC", "multiSortColumns": [], "isMultiSort": 0, "isView": true, "isPivot": true, "isAdvancedSearch": 1, "refresh": "1730123080914", "appId": "theta-dev-staging" }
        //  : {}
      },
    }),
    [activeTable, isFilterEnabled, filters]
  );

  const updateStatusParams = (item: any) => {
    let updatedSearch = _.cloneDeep(filters);
    if (!updatedSearch.search) {
      updatedSearch.search = [];
    }
    let index = _.findIndex(updatedSearch.search, function (singleCreteria) {
      return singleCreteria?.criteria?.rowIdentifier === "OrderStatusID";
    });
    if (index > -1) {
      updatedSearch.search.splice(index, 1);
    }

    updatedSearch.search.push(getStatusQuery(item.value, activeTable.tableId));
    dispatch(
      dynamicGridSagaActions.updateGrid({
        tableId: activeTable.tableId,
        filters: updatedSearch,
      })
    );
  };

  const getSelectedOption = () => {
    if (activeTable.tableId === 115) {
      return {
        displayName: "Open",
        value: "3",
      };
    }
    const orderStatus: any =
      filters &&
      _.find(filters.search, function (singleCreteria) {
        return singleCreteria?.criteria?.rowIdentifier === "OrderStatusID";
      });
    if (orderStatus?.query) {
      return _.find(constants.ORDER_STATUS_PARAMS, function (singleItem) {
        return singleItem.value == orderStatus.query;
      });
    }
    return {
      displayName: "Open",
      value: "3",
    };

  };

  return (
    <>
      {/* <Stack isVertical>
        <StackItem isStretch align="right">
          <GridActionBar>
            <div className="content-head">
              <div className="content-head-lt">
                <Title level={3}>All Orders</Title>
                <Title level={5}>Display subtitle here</Title>
              </div>
              <div className="content-head-rt">
                <Button type="primary">
                  <i className="icon-add" /> Create Order
                </Button>
 
                <ActionBar
                  gridMeta={gridMeta}
                  parentTableId={activeTable.tableId}
                  isFilterEnabled={isFilterEnabled}
                  handleUpdateFilter={updateFilterEnabled}
                  selectedTab={activeTable.tableId.toString()}
                  handleResetViewClick={handleResetViewClick}
                  orderStatus={getSelectedOption()}
                />
              </div>
            </div>
          </GridActionBar>
        </StackItem>
        <StackItem isStretch>
          <Card>
            <Stack className="order-status-wrapper">
              <StackItem className="order-status-items">
                <StackItem>
                  <OrderSummary dataLoading={dataLoading} info={info} />
                </StackItem>
              </StackItem>
              <StackItem isGrow isStretch>
                <Stack isVertical gutter="medium">
                  <StackItem className="select-status-block">
                    <Stack gutter="small">
                      <StackItem isGrow={!isGroupMode}>
                        <Stack gutter="medium">
                          <StackItem position="center">
                            <Label>Order Status:</Label>
                          </StackItem>
                          <StackItem>
                            <DropDown
                              options={constants.ORDER_STATUS_PARAMS}
                              updateHandler={updateStatusParams}
                              selectedOption={getSelectedOption()}
                              // isAutocomplete={true}
                              placeholder={"Enter Order Status value"}
                            />
                          </StackItem>
                        </Stack>
                      </StackItem>
                      {isGroupMode && (
                        <StackItem isGrow>
                          <Stack gutter="medium">
                            <StackItem position="center">
                              <Label>Grouped Edit Type:</Label>
                            </StackItem>
                            <StackItem>
                              <DropDown
                                options={constants.GROUP_EDIT_TYPES}
                                updateHandler={() => { }}
                                selectedOption={constants.GROUP_EDIT_TYPES[0]}
                                // isAutocomplete={true}
                                placeholder={"Enter Order Status value"}
                              />
                            </StackItem>
                          </Stack>
                        </StackItem>
                      )}
                    </Stack>
                  </StackItem>
                </Stack>
              </StackItem>
            </Stack>
            <Stack className="order-tbl">
              <Sheet isPage>
                <KitsModal></KitsModal>
 
                <StackItem isGrow isStretch>
                  <SheetBody>
                    <Stack isVertical gutter="medium">
                      <StackItem isStretch isGrow>
                        <Stack isVertical>
                          <StackItem isGrow>
                            <ThetaGridPaginated
                              // extendFilters={<Filters />}
                              onDomRef={handleGridRef}
                              key={activeTable.tableId}
                              config={templateConfig}
                              hasChildRows
                            />
                          </StackItem>
                        </Stack>
                      </StackItem>
                    </Stack>
                  </SheetBody>
                </StackItem>
              </Sheet>
            </Stack>
          </Card>
        </StackItem>
 
      </Stack> */}
      <Stack isVertical>
        <StackItem>
          <GridActionBar>
            <div className="content-head">
              {/* <div className="content-head-lt">
                <Title level={3}>All Orders</Title>
              </div> */}
              <div className="content-head-lt">
                <StackItem isStretch>
                  <div className="order-status-wrapper">
                    <div className="order-status-items">
                      <StackItem>
                        {!(
                          (!loading &&
                            (!info ||
                              (typeof info === "object" &&
                                Object.keys(info).length === 0))) ||
                          (loading &&
                            (!info ||
                              (typeof info === "object" &&
                                Object.keys(info).length === 0)))
                        ) && <OrderSummary dataLoading={loading} info={info} />}
                      </StackItem>
                    </div>
                  </div>
                </StackItem>
              </div>
              <Stack isVertical gutter="medium">
                <StackItem className="select-status-block">
                  <Stack gutter="small">
                    <StackItem isGrow={!isGroupMode}>
                      <Stack
                        gutter="medium"
                        align="right"
                        className="select-order-status"
                      >
                        <StackItem position="center">
                          <Label>Order Status:</Label>
                        </StackItem>
                        <StackItem>
                          <DropDown
                            disabled={activeTable.tableId === 115}
                            options={constants.ORDER_STATUS_PARAMS}
                            updateHandler={updateStatusParams}
                            selectedOption={getSelectedOption()}
                            placeholder={"Enter Order Status value"}
                          />
                        </StackItem>
                      </Stack>
                    </StackItem>
                    {isGroupMode && (
                      <StackItem isGrow>
                        <Stack gutter="medium" align="right">
                          <StackItem position="center">
                            <Label>Grouped Edit Type:</Label>
                          </StackItem>
                          <StackItem>
                            <DropDown
                              options={constants.GROUP_EDIT_TYPES}
                              updateHandler={() => {}}
                              selectedOption={constants.GROUP_EDIT_TYPES[0]}
                              // isAutocomplete={true}
                              placeholder={"Enter Order Status value"}
                            />
                          </StackItem>
                        </Stack>
                      </StackItem>
                    )}
                  </Stack>
                </StackItem>
              </Stack>
              <div className="content-head-rt">
                {/* <Link to="/create">
                  <Button type="primary">
                    <i className="icon-add" /> Create Order
                  </Button>
                </Link> */}

                <ActionBar
                  gridMeta={gridMeta}
                  parentTableId={activeTable.tableId}
                  isFilterEnabled={isFilterEnabled}
                  handleUpdateFilter={updateFilterEnabled}
                  selectedTab={activeTable.tableId.toString()}
                  handleResetViewClick={handleResetViewClick}
                  orderStatus={getSelectedOption()}
                />
              </div>
            </div>
          </GridActionBar>
        </StackItem>
        {/* <StackItem isStretch isGrow> */}
        <Sheet isPage className="order-tbl">
          <SheetBody isTransparent>
            <Stack isVertical>
              {/* <StackItem isStretch>
                  <div className="order-status-wrapper">
                    <div className="order-status-items">
                      <StackItem>
                        <OrderSummary dataLoading={dataLoading} info={info} />
                      </StackItem>
                    </div>
                    <div>
                      <Stack isVertical gutter="medium">
                        <StackItem className="select-status-block">
                          <Stack gutter="small">
                            <StackItem isGrow={!isGroupMode}>
                              <Stack gutter="medium">
                                <StackItem position="center">
                                  <Label>Order Status:</Label>
                                </StackItem>
                                <StackItem>
                                  <DropDown
                                    options={constants.ORDER_STATUS_PARAMS}
                                    updateHandler={updateStatusParams}
                                    selectedOption={getSelectedOption()}
                                    // isAutocomplete={true}
                                    placeholder={"Enter Order Status value"}
                                  />
                                </StackItem>
                              </Stack>
                            </StackItem>
                            {isGroupMode && (
                              <StackItem isGrow>
                                <Stack gutter="medium">
                                  <StackItem position="center">
                                    <Label>Grouped Edit Type:</Label>
                                  </StackItem>
                                  <StackItem>
                                    <DropDown
                                      options={constants.GROUP_EDIT_TYPES}
                                      updateHandler={() => {}}
                                      selectedOption={
                                        constants.GROUP_EDIT_TYPES[0]
                                      }
                                      // isAutocomplete={true}
                                      placeholder={"Enter Order Status value"}
                                    />
                                  </StackItem>
                                </Stack>
                              </StackItem>
                            )}
                          </Stack>
                        </StackItem>
                      </Stack>
                    </div>
                  </div>
                </StackItem> */}

              <StackItem isStretch isGrow>
                <KitsModal></KitsModal>
                <Stack isVertical gutter="tiny">
                  <StackItem isGrow isStretch>
                    <ThetaGridPaginated
                      // extendFilters={<Filters />}
                      onDomRef={handleGridRef}
                      key={activeTable.tableId}
                      config={templateConfig}
                      hasChildRows
                    />
                  </StackItem>
                </Stack>
              </StackItem>
            </Stack>
          </SheetBody>
        </Sheet>
        {/* </StackItem> */}
      </Stack>
      {isHealthCheckActive && (
        <HealthCheck
          isActive={isHealthCheckActive}
          handleOnClose={closeHealthCheck}
          tableId={activeTable.tableId}
        />
      )}
    </>
  );
};

export default Orders;
